import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import LanguageDropdown from '../LanguageDropdown'
import CountriesDropdown from '../CountriesDropdown'
import DomainDropdown from '../DomainDropdown'
import { useCreateDomainTubeWhitelistMutation, useUpdateDomainTubeWhitelistByIdMutation } from '../../redux/apis/domainsManagement/domains/dMDomainsTubeWhitelistApiSlice'

const EditCreateWhitelistChannel = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateDomainTubeWhitelistByIdMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateDomainTubeWhitelistMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      channel_name: record?.channel_name || '',
      domain_category: record?.domain?.domain_category || '',
      channel_url: record?.channel_url || '',
      language: record?.language?.id || null,
      country: record?.country?.id || null,
      domain: record?.domain?.id || null,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      channel_name: Yup.string().required('Please Enter Whitelist Channel Name'),
      channel_url: Yup.string().required('Please Enter Whitelist Channel URL'),
      language: Yup.number().required('Please Select Language'),
      country: Yup.number().required('Please Select Country'),
      domain: Yup.number().required('Please Select Domain')
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }
      for (let pair of formData.entries()) {
        console.log(`${pair[0]}:`, pair[1])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    if (SuccessAdd && state === 'create') {
      toast.success('Whitelist Channel created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Whitelist Channel updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])
  return (
    <Modal
      className='customModal'
      open={open}
      title={
        state === 'edit' ? `Edit Channel` : 'Create Channel'
      }
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">Channel URL</label>
        <Input
          type='text'
          name='channel_url'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.channel_url}
        />
        {validation.touched.channel_url && validation.errors.channel_url ? (
          <p className='text-danger'>{validation.errors.channel_url}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Channel Name</label>
        <Input
          type='text'
          name='channel_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.channel_name}
        />
        {validation.touched.channel_name && validation.errors.channel_name ? (
          <p className='text-danger'>{validation.errors.channel_name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <LanguageDropdown
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('language', e)
          }}
          value={validation.values?.language}
        />
        {validation.touched.language && validation.errors.language ? (
          <p className='text-danger'>{validation.errors.language}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <CountriesDropdown
          onChange={value => validation.setFieldValue('country', value)}
          onBlur={validation.handleBlur}
          value={validation.values?.country}
          validation={validation}
        />

        {validation.touched.country && validation.errors.country ? (
          <p className='text-danger'>{validation.errors.country}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <DomainDropdown
          createWhitelist={state === "create"}
          domain_category={validation.values?.domain_category}
          onChange={value => validation.setFieldValue('domain', value)}
          onBlur={validation.handleBlur}
          value={validation.values.domain}
          validation={validation}
        />
        {validation.touched.domain && validation.errors.domain ? (
          <p className='text-danger'>{validation.errors.domain}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateWhitelistChannel
